import { useGetDealFilterValues } from "@vega-api/generated/deal/deal";
import type { GetAllDealsV2Params } from "@vega-api/generated/types/getAllDealsV2Params";
import { m } from "@vega-core/paraglide/messages";
import { useTableFilters } from "@vega-modules/components/Table/TableFilters/hooks/useTableFilters";
import {
  FilterType,
  TableFilterId,
} from "@vega-modules/components/Table/TableFilters/types";

import { type TableFiltersConfig } from "../../../components/Table/TableFilters/types";

const sortOptions = [
  {
    value: "closingDate",
    label: m.coInvestments_filters_sortClosingDateAsc(),
  },
  {
    value: "-closingDate",
    label: m.coInvestments_filters_sortClosingDateDesc(),
  },
];

export const useCoInvestmentFilters = () => {
  const { data: filterOptions, isLoading: isFilterOptionsLoading } =
    useGetDealFilterValues({
      query: {
        select: ({ data }) => data,
      },
    });

  const filtersConfig = {
    filters: [
      {
        id: "searchQuery",
        type: FilterType.Search,
        label: m.coInvestments_filters_search(),
        props: {
          placeholder: m.coInvestments_filters_searchPlaceholder(),
        },
      },
      {
        id: "activeOrPast",
        type: FilterType.Dropdown,
        label: m.coInvestments_filters_opportunityStatus(),
        props: {
          placeholder: m.coInvestments_filters_allOpportunities(),
          options: filterOptions?.activeOrPast || [],
        },
      },
      {
        id: "sort",
        type: FilterType.Dropdown,
        label: m.coInvestments_filters_sortBy(),
        props: {
          placeholder: m.coInvestments_filters_sortByPlaceholder(),
          options: sortOptions,
        },
      },
    ],
    showResetButton: true,
    maxShownFilters: 3,
  } as const satisfies TableFiltersConfig;

  const { filterState, setFilterValue, RenderFilters, hasActiveFilters } =
    useTableFilters({
      id: TableFilterId.CoInvestmentsGP,
      config: filtersConfig,
      isLoading: isFilterOptionsLoading,
      syncWithURL: true,
      showSavedFilters: true,
      persistInSession: false,
    });

  const sortValue = filterState.sort?.value;
  const queryParams: Partial<GetAllDealsV2Params> = {
    searchQuery: filterState.searchQuery,
    activeOrPast: filterState.activeOrPast?.value,
    sort: sortValue ? [sortValue] : undefined,
  };

  return {
    filterState,
    setFilterValue,
    RenderFilters,
    hasActiveFilters,
    queryParams,
  };
};
